import { CoreIcon } from '../core-icon';
import qrcodeColorSVG from '../../assets/icons/qrcode-color.svg';
import type { IconProps } from '../core-icon';

export const QrcodeColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={qrcodeColorSVG} {...props} />;
};
